import './App.css';
import MainDisplay from "./mainDisplay"
import { PersistGate } from 'redux-persist/integration/react'
import configureStore from './store/configureStore';
import {Provider} from 'react-redux';

const {store, persistor} = configureStore();

const env = process.env.REACT_APP_ENVIRONMENT
const version = process.env.REACT_APP_VERSION

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <MainDisplay />
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;